<template>
  <div>
    <SoAlert class="mb-10">
      Before a refund is processed, ensure we've got a photo of the meter that
      shows a valid read.
    </SoAlert>
    <SoRadioGroup
      v-model="hasMeterPhoto"
      :label="`Refund amount £${refundAmount}. Have you received a photo and submitted the read?`"
      :items="[
        { text: 'Yes', value: true },
        { text: 'No', value: false },
      ]"
      @update:model-value="$emit('update:model-value', $event)"
    />
    <SoAlert v-show="!hasMeterPhoto" type="error">
      We can’t create a refund without a photo submission confirmation.
    </SoAlert>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoRadioGroup from "@/components/formControls/SoRadioGroup.vue"
  import SoAlert from "@/components/SoAlert.vue"

  export default defineComponent({
    components: {
      SoRadioGroup,
      SoAlert,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
      },
      refundAmount: {
        type: String,
        default: null,
      },
    },
    emits: ["update:model-value"],
    data() {
      return {
        hasMeterPhoto: false,
      }
    },
  })
</script>
